<div class="image-container">
  <div
    [ngClass]="[
      'image-container-images',
      'total-' + inlineImage?.length + '-items'
    ]"
    *ngFor="let image of inlineImage"
  >
    <digital-platform-inline-image
      [imageOverlayColor]="cardColor"
      [excludeImageOverride]="excludeImgOverrideAttrs"
      [inlineImageOverride]="image"
      [forceImageToContainer]="true"
      [class]="stringOrNullToString(image.class)"
    ></digital-platform-inline-image>
  </div>

  <div class="image-container-content" [ngClass]="imageContainerContentClasses">
    <div
      *ngIf="svgIconClass?.iconClass"
      class="icon-wrapper"
      [ngClass]="iconVisibilityClass"
    >
      <div
        [ngClass]="{
          'es-icon-container': esServicesAvailable,
          'icon-container': !esServicesAvailable
        }"
      >
        <digital-platform-icon
          [icon]="svgIconClass?.iconClass ?? ''"
          [height]="55"
          [width]="55"
          [color]="'container-blue'"
        ></digital-platform-icon>
      </div>
    </div>

    <div class="card-text">
      <div class="card-name">
        <digital-platform-rsx-rich-text
          *ngIf="carouselCardType && carouselCardType.name"
          body="<strong style='font-size: smaller; color: black;'>{{
            carouselCardType.name.toUpperCase()
          }}</strong>"
        ></digital-platform-rsx-rich-text>
      </div>

      <div class="card-title" data-automation-id="card-title">
        <digital-platform-rsx-rich-text
          *ngIf="richTextTitle"
          body="<span style='color: black;'>{{ richTextTitle }}<span>"
        ></digital-platform-rsx-rich-text>
      </div>

      <div *ngFor="let ctaButtonInstance of ctaButton">
        <digital-platform-cta-button
          class="view-btn"
          [analyticsLinkText]="
            ctaButtonInstance.analyticsLinkText || 'insights-image'
          "
          [chevron]="ctaButtonInstance.chevron"
          [ctaPosition]="ctaButtonInstance.ctaPosition"
          [ctaSize]="ctaButtonInstance.ctaSize"
          [ctaStyle]="ctaButtonInstance.ctaStyle"
          [ctaWidth]="ctaButtonInstance.ctaWidth"
          [fontAwesomeIconClass]="ctaButtonInstance.fontAwesomeIconClass"
          [marginBottomClass]="ctaButtonInstance.marginBottomClass"
          [marginTopClass]="ctaButtonInstance.marginTopClass"
          [url]="ctaButtonInstance.url"
          [visibility]="ctaButtonInstance.visibility"
        ></digital-platform-cta-button>
      </div>
    </div>
  </div>
</div>
